import Entity from '../entity';
import City from '../city';
import Country from '../country';
export default class Airport extends Entity<string> {
  name: string;
  nameWithCode: string;
  countryId: string;
  cityId: string;
  parentId: string;
  airportIsActive: boolean;
  isCity: boolean;
  country: Country;
  city: City;
  countryName: string;
  latitude: string;
  longitude: string;
  expediaId: number;
  isDeleted: boolean;
  deleterUserId: any;
  deletionTime: any;
  lastModificationTime: string;
  lastModifierUserId: number;
  creationTime: string;
  creatorUserId: any;
  nameUnicode:string;
}
